(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cojoness-decue-motion"]) return;
  try {
    
  (() => {
    let observer;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    // Les navigateurs recents savent lier une animation au defilement :
    // c'est plus sur, car l'affichage ne depend alors d'aucun script.
    const scrollLinked =
      typeof CSS !== 'undefined' &&
      typeof CSS.supports === 'function' &&
      CSS.supports('animation-timeline', 'view()');

    const revealNow = (el) => el.classList.add('cj-in');

    // Comptent pour UN SEUL bloc : les carrousels horizontaux, et les depliants
    // (sinon on animerait la reponse cachee, qui risquerait de rester invisible
    // au moment ou le client ouvre la question).
    const NO_SPLIT = 'details, .rw-container, .cj-demo__piste, .slider, .swiper, .slideshow, .product__media-list';

    // On anime les vrais elements de contenu (titres, textes, images, listes,
    // boutons) plutot que la section entiere : c'est ce qui fait que l'animation
    // continue tout au long de la descente au lieu de jouer une seule fois en haut.
    const PICK =
      'h1, h2, h3, h4, h5, h6, p, img, picture, video, iframe, figure, blockquote, ul, ol, table, button, .button';

    const MEDIA = 'img, svg, video, picture, iframe, canvas';

    // Attention : pour une balise <img>, querySelector ne trouve rien (il ne
    // cherche que les descendants). Sans le matches(), aucune image ne serait animee.
    const hasContent = (el) =>
      el.textContent.trim().length > 0 || el.matches(MEDIA) || !!el.querySelector(MEDIA);

    const chunksOf = (section) => {
      const blocks = Array.prototype.slice.call(section.querySelectorAll(NO_SPLIT));
      const pieces = Array.prototype.slice.call(section.querySelectorAll(PICK)).filter(hasContent);
      const candidates = blocks.concat(pieces);

      // on ne garde que l'element le plus englobant de chaque branche
      const outer = candidates.filter(
        (el) => !candidates.some((other) => other !== el && other.contains(el))
      );
      if (!outer.length) return [section];

      // Regroupement en "cartes" : quand une icone, un titre et un texte forment
      // un petit ensemble, ils doivent apparaitre ENSEMBLE, pas separement.
      const countInside = (el) => outer.reduce((n, c) => n + (el.contains(c) ? 1 : 0), 0);

      const grouped = [];
      outer.forEach((el) => {
        let node = el.parentElement;
        let card = null;
        while (node && node !== section) {
          const inside = countInside(node);
          if (inside > 4) break;
          const height = node.getBoundingClientRect().height || 0;
          if (inside >= 2 && height <= 600) card = node;
          node = node.parentElement;
        }
        const chosen = card || el;
        if (grouped.indexOf(chosen) === -1) grouped.push(chosen);
      });

      const kept = grouped.filter(
        (el) => !grouped.some((other) => other !== el && other.contains(el))
      );

      kept.sort((a, b) =>
        a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1
      );
      return kept;
    };

    const collect = (root) => {
      const targets = [];
      root.querySelectorAll(':scope > .shopify-section, :scope > section, :scope > div[id^="shopify-section"]').forEach((section) => {
        if (section.querySelector('.product__info-container')) return;
        if (section.querySelector('[data-cojoness-decue-motion]')) return;
        chunksOf(section).forEach((el) => {
          if (el && targets.indexOf(el) === -1 && targets.length < 200) targets.push(el);
        });
      });
      return targets;
    };

    const init = () => {
      observer?.disconnect();
      if (!document.querySelector('[data-cojoness-decue-motion]')) return;

      const root = document.getElementById('MainContent') || document.querySelector('main');
      if (!root) return;
      root.setAttribute('data-cojoness-decue', '');

      if (reduced.matches) return;

      const targets = collect(root);
      if (!targets.length) return;

      // Petit decalage entre elements voisins : ils arrivent l'un apres l'autre.
      const counters = new Map();
      const ranks = new Map();
      targets.forEach((el) => {
        const used = counters.get(el.parentElement) || 0;
        counters.set(el.parentElement, used + 1);
        ranks.set(el, Math.min(used, 3));
      });

      // Voie 1 : tout est gere par le CSS, lie au defilement. Rien d'autre a faire.
      if (scrollLinked) {
        targets.forEach((el) => {
          el.classList.add('cj-item');
          const rank = ranks.get(el);
          if (rank > 0) el.classList.add('cj-r' + rank);
        });
        return;
      }

      // Voie 2 : navigateurs plus anciens.
      if (!('IntersectionObserver' in window)) return;

      targets.forEach((el) => {
        el.style.setProperty('--cj-delay', ranks.get(el) * 90 + 'ms');
        el.classList.add('cj-reveal');
      });

      let pending = targets.slice();

      const revealIfVisible = () => {
        if (!pending.length) return;
        const height = window.innerHeight || document.documentElement.clientHeight || 0;
        pending = pending.filter((el) => {
          const box = el.getBoundingClientRect();
          if (box.top < height && box.bottom > 0) {
            revealNow(el);
            observer.unobserve(el);
            return false;
          }
          return !el.classList.contains('cj-in');
        });
      };

      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            revealNow(entry.target);
            observer.unobserve(entry.target);
            pending = pending.filter((el) => el !== entry.target);
          });
        },
        { threshold: 0.02, rootMargin: '0px 0px -8% 0px' }
      );

      // Observation immediate : ne jamais dependre d'une image d'animation,
      // elle n'arrive pas quand l'onglet est en arriere-plan.
      targets.forEach((el) => observer.observe(el));

      // Second mecanisme, independant du premier : au moindre defilement on
      // affiche ce qui entre a l'ecran. Ainsi l'animation ne peut pas rester bloquee.
      let waiting = false;
      const onScroll = () => {
        if (waiting) return;
        waiting = true;
        window.setTimeout(() => {
          waiting = false;
          revealIfVisible();
        }, 90);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      window.addEventListener('load', onScroll);
      window.setTimeout(revealIfVisible, 300);
    };

    // Garde-fou du haut de page : si l'animation d'entree n'a pas joue
    // (navigateur qui bloque les animations), on affiche quand meme.
    const guardTop = () => {
      if (document.visibilityState !== 'visible') return;
      const height = window.innerHeight || document.documentElement.clientHeight || 0;
      document
        .querySelectorAll('#MainContent .product__info-container > *, #MainContent .product__media-wrapper')
        .forEach((el) => {
          const box = el.getBoundingClientRect();
          // uniquement ce qui est REELLEMENT a l'ecran : ailleurs, l'element est
          // legitimement invisible en attendant qu'on descende jusqu'a lui.
          if (box.top >= height || box.bottom <= 0) return;
          if (parseFloat(window.getComputedStyle(el).opacity) < 0.99) {
            el.style.animation = 'none';
            el.style.opacity = '1';
            el.style.transform = 'none';
          }
        });
    };
    const scheduleGuard = () => window.setTimeout(guardTop, 2800);
    scheduleGuard();
    document.addEventListener('visibilitychange', scheduleGuard);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:section:unload', () => observer?.disconnect());
    reduced.addEventListener('change', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cojoness-motion-global"]) return;
  try {
    
  (() => {
    let observer;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    // Les navigateurs recents savent lier une animation au defilement :
    // c'est plus sur, car l'affichage ne depend alors d'aucun script.
    const scrollLinked =
      typeof CSS !== 'undefined' &&
      typeof CSS.supports === 'function' &&
      CSS.supports('animation-timeline', 'view()');

    const revealNow = (el) => el.classList.add('cj-in');

    // Comptent pour UN SEUL bloc : les carrousels horizontaux, et les depliants
    // (sinon on animerait la reponse cachee, qui risquerait de rester invisible
    // au moment ou le client ouvre la question).
    const NO_SPLIT = 'details, .rw-container, .cj-demo__piste, .slider, .swiper, .slideshow, .product__media-list';

    // On anime les vrais elements de contenu (titres, textes, images, listes,
    // boutons) plutot que la section entiere : c'est ce qui fait que l'animation
    // continue tout au long de la descente au lieu de jouer une seule fois en haut.
    const PICK =
      'h1, h2, h3, h4, h5, h6, p, img, picture, video, iframe, figure, blockquote, ul, ol, table, button, .button';

    const MEDIA = 'img, svg, video, picture, iframe, canvas';

    // Attention : pour une balise <img>, querySelector ne trouve rien (il ne
    // cherche que les descendants). Sans le matches(), aucune image ne serait animee.
    const hasContent = (el) =>
      el.textContent.trim().length > 0 || el.matches(MEDIA) || !!el.querySelector(MEDIA);

    const chunksOf = (section) => {
      const blocks = Array.prototype.slice.call(section.querySelectorAll(NO_SPLIT));
      const pieces = Array.prototype.slice.call(section.querySelectorAll(PICK)).filter(hasContent);
      const candidates = blocks.concat(pieces);

      // on ne garde que l'element le plus englobant de chaque branche
      const outer = candidates.filter(
        (el) => !candidates.some((other) => other !== el && other.contains(el))
      );
      if (!outer.length) return [section];

      // Regroupement en "cartes" : quand une icone, un titre et un texte forment
      // un petit ensemble, ils doivent apparaitre ENSEMBLE, pas separement.
      const countInside = (el) => outer.reduce((n, c) => n + (el.contains(c) ? 1 : 0), 0);

      const grouped = [];
      outer.forEach((el) => {
        let node = el.parentElement;
        let card = null;
        while (node && node !== section) {
          const inside = countInside(node);
          if (inside > 4) break;
          const height = node.getBoundingClientRect().height || 0;
          if (inside >= 2 && height <= 600) card = node;
          node = node.parentElement;
        }
        const chosen = card || el;
        if (grouped.indexOf(chosen) === -1) grouped.push(chosen);
      });

      const kept = grouped.filter(
        (el) => !grouped.some((other) => other !== el && other.contains(el))
      );

      kept.sort((a, b) =>
        a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1
      );
      return kept;
    };

    const collect = (root) => {
      const targets = [];
      root.querySelectorAll(':scope > .shopify-section, :scope > section, :scope > div[id^="shopify-section"]').forEach((section) => {
        if (section.querySelector('.product__info-container')) return;
        if (section.querySelector('.cj-hero')) return;
        if (section.querySelector('[data-cojoness-decue-motion]')) return;
        chunksOf(section).forEach((el) => {
          if (el && targets.indexOf(el) === -1 && targets.length < 200) targets.push(el);
        });
      });
      return targets;
    };

    const init = () => {
      observer?.disconnect();
      if (!document.querySelector('[data-cojoness-motion-global]')) return;
      if (document.querySelector('[data-cojoness-decue-motion]')) return;

      const root = document.getElementById('MainContent') || document.querySelector('main');
      if (!root) return;
      root.setAttribute('data-cojoness-decue', '');

      if (reduced.matches) return;

      const targets = collect(root);
      if (!targets.length) return;

      // Petit decalage entre elements voisins : ils arrivent l'un apres l'autre.
      const counters = new Map();
      const ranks = new Map();
      targets.forEach((el) => {
        const used = counters.get(el.parentElement) || 0;
        counters.set(el.parentElement, used + 1);
        ranks.set(el, Math.min(used, 3));
      });

      // Voie 1 : tout est gere par le CSS, lie au defilement. Rien d'autre a faire.
      if (scrollLinked) {
        targets.forEach((el) => {
          el.classList.add('cj-item');
          const rank = ranks.get(el);
          if (rank > 0) el.classList.add('cj-r' + rank);
        });
        return;
      }

      // Voie 2 : navigateurs plus anciens.
      if (!('IntersectionObserver' in window)) return;

      targets.forEach((el) => {
        el.style.setProperty('--cj-delay', ranks.get(el) * 90 + 'ms');
        el.classList.add('cj-reveal');
      });

      let pending = targets.slice();

      const revealIfVisible = () => {
        if (!pending.length) return;
        const height = window.innerHeight || document.documentElement.clientHeight || 0;
        pending = pending.filter((el) => {
          const box = el.getBoundingClientRect();
          if (box.top < height && box.bottom > 0) {
            revealNow(el);
            observer.unobserve(el);
            return false;
          }
          return !el.classList.contains('cj-in');
        });
      };

      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            revealNow(entry.target);
            observer.unobserve(entry.target);
            pending = pending.filter((el) => el !== entry.target);
          });
        },
        { threshold: 0.02, rootMargin: '0px 0px -8% 0px' }
      );

      // Observation immediate : ne jamais dependre d'une image d'animation,
      // elle n'arrive pas quand l'onglet est en arriere-plan.
      targets.forEach((el) => observer.observe(el));

      // Second mecanisme, independant du premier : au moindre defilement on
      // affiche ce qui entre a l'ecran. Ainsi l'animation ne peut pas rester bloquee.
      let waiting = false;
      const onScroll = () => {
        if (waiting) return;
        waiting = true;
        window.setTimeout(() => {
          waiting = false;
          revealIfVisible();
        }, 90);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      window.addEventListener('load', onScroll);
      window.setTimeout(revealIfVisible, 300);
    };

    // Garde-fou du haut de page : si l'animation d'entree n'a pas joue
    // (navigateur qui bloque les animations), on affiche quand meme.
    const guardTop = () => {
      if (document.visibilityState !== 'visible') return;
      const height = window.innerHeight || document.documentElement.clientHeight || 0;
      document
        .querySelectorAll('#MainContent .product__info-container > *, #MainContent .product__media-wrapper')
        .forEach((el) => {
          const box = el.getBoundingClientRect();
          // uniquement ce qui est REELLEMENT a l'ecran : ailleurs, l'element est
          // legitimement invisible en attendant qu'on descende jusqu'a lui.
          if (box.top >= height || box.bottom <= 0) return;
          if (parseFloat(window.getComputedStyle(el).opacity) < 0.99) {
            el.style.animation = 'none';
            el.style.opacity = '1';
            el.style.transform = 'none';
          }
        });
    };
    const scheduleGuard = () => window.setTimeout(guardTop, 2800);
    scheduleGuard();
    document.addEventListener('visibilitychange', scheduleGuard);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:section:unload', () => observer?.disconnect());
    reduced.addEventListener('change', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
     
 class LmLookBook extends HTMLElement {
  constructor() {
    super();

    this.injectVendorScripts();
    this.querySelectorAll('.shortcut-lookbook-point-list-item').forEach((elem) => {
      this.handleTooltip(elem);
    });
  }

  async injectVendorScripts() {
    if (!window.FloatingUICore) {
      const script = document.createElement('script');
      script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.0');
      document.head.appendChild(script);
    }
    if (!window.FloatingUIDOM) {
      await new Promise((r) => setTimeout(r, 500));

      const script = document.createElement('script');
      script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.1');
      document.head.appendChild(script);
    }
  }

  handleTooltip(elem) {
    const btn = elem.querySelector('button');
    const tooltip = elem.querySelector('.lm-tooltip');
    let isTooltipHovered = false;
    let shouldCloseTooltip = false;
    let closeTimer = null;

    function update() {
      window.FloatingUIDOM.computePosition(btn, tooltip, {
        middleware: [
          window.FloatingUIDOM.offset(0),
          window.FloatingUIDOM.autoPlacement(),
        ],
      }).then(({ x, y }) => {
        Object.assign(tooltip.style, {
          left: `${x}px`,
          top: `${y}px`,
        });
      });
    }

    function showTooltip() {
      clearTimeout(closeTimer);
      tooltip.classList.add('show');
      tooltip.classList.remove('hiding');
      shouldCloseTooltip = false;
      update();
    }

    function hideTooltip() {
      if (isTooltipHovered) return;
      
      shouldCloseTooltip = true;
      closeTimer = setTimeout(() => {
        if (shouldCloseTooltip) {
          tooltip.classList.remove('show');
          tooltip.classList.add('hiding');
          setTimeout(() => {
            tooltip.classList.remove('hiding');
          }, 200);
        }
      }, 100);
    }

    // Detect if the device is touch-capable
    const isTouchDevice = window.matchMedia("(pointer: coarse)").matches;

    if (isTouchDevice) {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        if (tooltip.classList.contains('show')) {
          hideTooltip();
        } else {
          showTooltip();
        }
      });

      // Hide the tooltip when clicking outside
      document.addEventListener('click', (e) => {
        if (!elem.contains(e.target)) {
          hideTooltip();
        }
      });
    } else {
      // Desktop behavior
      btn.addEventListener('mouseenter', showTooltip);
      btn.addEventListener('mouseleave', hideTooltip);
      btn.addEventListener('focus', showTooltip);
      btn.addEventListener('blur', hideTooltip);
      
      // Add events to the tooltip itself
      tooltip.addEventListener('mouseenter', () => {
        isTooltipHovered = true;
        showTooltip();
      });
      
      tooltip.addEventListener('mouseleave', () => {
        isTooltipHovered = false;
        hideTooltip();
      });
      
      // Make the tooltip clickable
      tooltip.addEventListener('click', (e) => {
        e.stopPropagation();
      });
    }
  }
}

customElements.define('shortcut-lookbook', LmLookBook);


  } catch(e) { console.error(e); }
})();
})();
